export const HS_SEARCH_HISTORY_LIMIT = 10
export const ALGOLIA_KEY_PREFIX = 'AUTOCOMPLETE_RECENT_SEARCHES'
export const DELAY_TO_SAVE_SEARCH_MS = 1000
export const HS_SEARCH_HISTORY_KEY = 'HS_SEARCH_HISTORY'
